@if (view()) {
  <!-- Fondo: un clic fuera del panel cierra. No es un control propio —para
       teclado están Escape y la X—, así que queda fuera del árbol accesible. -->
  <div class="event-dialog__backdrop" aria-hidden="true" (click)="close()"></div>

  <section
    #panel
    class="event-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="event-dialog-title"
  >
    <!-- Fuera de la zona con scroll: la X se ve siempre, también en la hoja de móvil. -->
    <div class="event-dialog__bar">
      @if (detail()?.fromDay) {
        <button type="button" class="event-dialog__back" (click)="back()">
          {{ copy.dialogBack }}
        </button>
      }
      <button
        type="button"
        class="event-dialog__close"
        [attr.aria-label]="copy.dialogClose"
        (click)="close()"
      >
        <app-icon [icon]="closeIcon" [size]="20" />
      </button>
    </div>

    <div class="event-dialog__body">
      @if (detail(); as current) {
        @if (imageUrl(); as src) {
          <!-- <img> normal y no NgOptimizedImage: las dimensiones del cartel no se
               conocen. Carga inmediata, que el diálogo ya está abierto. -->
          <div class="event-dialog__media">
            <img
              class="event-dialog__image"
              [src]="src"
              [alt]="imageAlt()"
              loading="eager"
              (error)="onImageError(src)"
            />
          </div>
        }

        <div class="event-dialog__tags">
          <span class="event-dialog__type">{{ typeLabel() }}</span>
          @if (current.event.game; as game) {
            <span class="event-dialog__game">{{ game.name }}</span>
          }
        </div>

        <h2 id="event-dialog-title" class="event-dialog__title">{{ current.event.name }}</h2>

        <div class="event-dialog__facts">
          <p class="event-dialog__date">
            {{ dateLabel() }}
            @if (timeLabel()) {
              <span class="event-dialog__time">{{ copy.eventTimeFrom }} {{ timeLabel() }}</span>
            }
          </p>
          @if (current.event.format) {
            <p class="event-dialog__format">{{ current.event.format }}</p>
          }
          <p class="event-dialog__location">
            <app-icon [icon]="mapPinIcon" [size]="16" />
            {{ current.event.location }}
          </p>
          @if (priceLabel()) {
            <p class="event-dialog__price">{{ priceLabel() }}</p>
          }
        </div>

        <!-- Texto plano por interpolación, nunca innerHTML (D15): un <b> escrito
             por el admin se ve como texto. Los saltos de línea los respeta el CSS. -->
        @if (current.event.description) {
          <p class="event-dialog__description">{{ current.event.description }}</p>
        }

        @if (current.event.url) {
          <a
            class="event-dialog__cta"
            [href]="current.event.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ copy.dialogMoreInfo }}
            <app-icon [icon]="externalLinkIcon" [size]="16" />
          </a>
        }
      } @else if (day(); as current) {
        <h2 id="event-dialog-title" class="event-dialog__title">{{ dayTitle() }}</h2>
        <div class="event-dialog__list">
          @for (event of current.events; track event.id) {
            <app-event-card [event]="event" />
          }
        </div>
      }
    </div>
  </section>
}
